export default __webpack_public_path__ + "static/media/online-study.24587d56.svg";